import { render } from "./PositiveModal.vue?vue&type=template&id=22c5b10d"
import script from "./PositiveModal.vue?vue&type=script&lang=js"
export * from "./PositiveModal.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__